const themeKey  = 'aHMtbG9jYWwtdGhlbWU='
const localeKey = 'aHMtbG9jYWwtbG9jYWxl'

const authKey = btoa(`auth-${process.env.VUE_APP_TENANT_ID}`)
const tenantKey = btoa(`tower-tenant`)

function parseLocalJson (key) {
  const val = window.localStorage.getItem(key)
  if (!val) { return {} }

  try {
    return JSON.parse(atob(val))
  } catch {
    window.localStorage.removeItem(key)
    return {}
  }
}

export function deleteLocalItem (item) {
  window.localStorage.removeItem(item)
}

export function safeExternalUrl (value) {
  if (!value) { return null }

  try {
    const url = new URL(value.trim())
    if (url.protocol === 'http:' || url.protocol === 'https:') {
      return url.href
    }
  } catch {
    return null
  }

  return null
}

export function setTheme(theme) {
  window.localStorage.setItem(themeKey, theme)
}

export function getTheme () {
  return window.localStorage.getItem(themeKey) || 'light'
}

export function setLocale (locale) {
  window.localStorage.setItem(localeKey, locale)
}

export function getLocale () {
  return window.localStorage.getItem(localeKey) || 'es-MX'
}

export function setAuth (auth) {
  return window.localStorage.setItem(authKey, btoa(JSON.stringify(auth)))
}

export function getAuth () {
  return parseLocalJson(authKey)
}

export function deleteAuth () {
  window.localStorage.removeItem(authKey)
}

export function setTenant (tenant) {
  return window.localStorage.setItem(tenantKey, btoa(JSON.stringify(tenant)))
}

export function getTenant () {
  return parseLocalJson(tenantKey)
}

export function deleteTenant () {
  window.localStorage.removeItem(tenantKey)
}
